import AppliedFilters from "@/components/dashboard/applied/filters";
import RecommendedFilters from "@/components/dashboard/recommended/filters";

import AppliedJobCard from "./applied/appliedJobCard";
import JobStatusDescription from "./applied/jobStatusDescription";
import BannerSection from "./banner";
import RecommendedJobDescription from "./recommended/jobDescription";
import RecommendedJobCard from "./recommended/recommendedJobCard";
import SavedJobDescription from "./saved/jobDescription";
import SavedJobCard from "./saved/savedJobCard";

type DashboardMap = {
  [key in DashboardSectionKey]: React.ComponentType;
};

export const appliedPageMap: Partial<DashboardMap> = {
  APPLIED_JOB_CARD: AppliedJobCard,
  JOB_STATUS_DESCRIPTION: JobStatusDescription,
  APPLIED_FILTERS: AppliedFilters,
  BANNER_SECTION: BannerSection,
};

export const recommendedPageMap: Partial<DashboardMap> = {
  RECOMMENDED_JOB_CARD: RecommendedJobCard,
  RECOMMENDED_JOB_DESCRIPTION: RecommendedJobDescription,
  RECOMMENDED_FILTERS: RecommendedFilters,
  BANNER_SECTION: BannerSection,
};

export const savedPageMap: Partial<DashboardMap> = {
  SAVED_JOB_CARD: SavedJobCard,
  SAVED_JOB_DESCRIPTION: SavedJobDescription,
  BANNER_SECTION: BannerSection,
};
